module.exports = "/lucky-balls/img/regular_game/check_infoBar/check_010.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/regular_game/check_infoBar/check_010.png
// module id = 1134
// module chunks = 0